export default {
    icons: {
        like: '/images/like.svg',
        flip: '/images/flip.svg?v=2',
        play: '/images/play.svg?v=2',
        pause: '/images/pause.svg?v=2',
        pen: '/images/pen.svg?v=2',
        music: '/images/music.svg?v=2',
        arrow: '/images/arrow-right.svg?v=2',
        loader: '/images/loader.svg?v=2',
        plus: '/images/plus.svg?v=2',
        dots: '/images/dots.svg?v=2',
        star: '/images/star.svg?v=2',
        starFilled: '/images/star-filled.svg?v=1',
        remove: '/images/remove.svg?v=2',
        google: '/images/google.svg?v=2',
        apple: '/images/apple-icon.svg?v=1',
        info: '/images/info.svg?v=2',
        cards: '/images/cards.svg?v=2',
        analytics: '/images/analytics.svg?v=2',
    }
}